<template>
	<nav class="filter">
		<ul class="filter__list">
			<li class="filter__item" v-for="bookeetype in bookeetypes" :key="bookeetype.id">
				<button type="button" class="filter__button button"
					v-bind:class="{ 'filter__button--active' : filter.includes(bookeetype.id),
					'filter__button--loading' : loading }" @click="toggle(bookeetype.id)">
					{{ sanitizeName(bookeetype.name) }}
				</button>
			</li>
		</ul>
	</nav>
</template>

<script>
import axios from 'axios';

export default {
	name: 'bookeetypefilter',
	props: ['filter'],
	data () {
		return {
			loading: true,
			bookeetypes: Array(4).fill(0).map((o, i) => {
				return {
					'id': i,
					'name': '████████'.substr(Math.floor(Math.random() * 5) + 1)
				};
			})
		};
	},
	mounted () {
		axios.get('/bookeetypes?expand=remark&provId=47')
			.then(response => {
				this.bookeetypes = response.data;
				this.bookeetypes.sort((a,b) => (a.name.localeCompare(b.name, undefined, {numeric: true})));
				this.loading = false;
			}).catch(error => {
				console.log(error);
			});
	},
	methods: {
		sanitizeName (name) {
			if (!this.loading) {
				return name.replace(/^(\d)*(\W|\s)*/, '');
			}
			return name;
		},
		toggle (id) {
			const i = this.filter.indexOf(id);
			if (i > -1) {
				this.filter.splice(i, 1);
			} else {
				this.filter.push(id);
			}
		}
	}

};
</script>

<style lang="scss">
.filter {
	margin-bottom: 1rem;
	position: relative;
	padding-bottom: .6rem;
	z-index: 2;
	&:after {
		content: '';
		background: linear-gradient(to bottom, rgba(black, 0.2), rgba(black, 0));
		position: absolute;
		left: 0;
		right: 0;
		bottom: -.6rem;
		height: .6rem;
	}
	&__list {
		display: flex;
		flex-wrap: wrap;
		@include smaller(600) {
			margin: 0 -.2rem;
		};
		align-items: stretch;

	}
	&__item {
		margin: 0 .8rem .6rem 0;
		display: inline-block;
		width: 12em;
		@include smaller(600) {
			margin: 0 .2rem .4rem;
			width: calc(33.3% - .4rem);
		};
		@include smaller(400) {
			width: calc(50% - .4rem);
		};
	}
	&__button {
		outline: none;
		background: $filter_bg;
		border: 0.15rem solid $filter_border;
		padding: 0.3rem 1rem;
		color: $filter_txt;
		line-height: 1.2;
		font-size: .9rem;
		width: 100%;
		height: 100%;
		text-align: left;
		border-radius: .2rem;
		@include smaller(900) {
			font-size: 0.8rem;
			padding: 0.2rem 0.5rem;
		};
		&:hover, &:focus {
			box-shadow: inset 0 0 1px 1px $filter_bg;
		}
		&--loading {
			filter: grayscale(1);
			animation: load 1.3s infinite cubic-bezier(.5,.8,.8,.5);
		}
		&--active {
			border-color: transparent;
			background: $filter_bg_active;
			color: $filter_txt_active;
		}
	}
}
</style>
